import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import useNotificationStore from './notificationStore';

const useUIStore = create(
  persist(
    (set) => ({
      sidebarOpen: true,
      sidebarWidth: 72,
      sidebarCollapsed: true,
      mobileDrawerOpen: false,
      contentListView: 'grid', // 'grid' or 'list'
      notifications: [],
      
      // Notification actions - redirects to notificationStore for compatibility
      addNotification: (notification) => {
        // Redirect to notificationStore's showNotification method
        const { showNotification } = useNotificationStore.getState();
        
        // Handle both 'type' and 'severity' properties for backward compatibility
        const type = notification.type || notification.severity || 'info';
        
        showNotification({
          message: notification.message,
          type,
          title: notification.title,
          duration: notification.duration || 5000
        });
        
        // Still update local state for any components that might read from it
        set((state) => {
          const id = notification.id || Math.random().toString(36).substring(2, 9);
          const newNotification = {
            id,
            message: notification.message,
            type,
            title: notification.title,
            duration: notification.duration || 5000,
            timestamp: new Date().toISOString(),
          };
          
          return {
            notifications: [...state.notifications, newNotification],
          };
        });
      },
      
      removeNotification: (id) => set((state) => ({
        notifications: state.notifications.filter(notification => notification.id !== id),
      })),
      
      clearAllNotifications: () => set({ notifications: [] }),
      
      // Sidebar actions
      toggleSidebar: () => set(state => ({ sidebarOpen: !state.sidebarOpen })),
      openSidebar: () => set({ sidebarOpen: true }),
      closeSidebar: () => set({ sidebarOpen: false }),
      
      // Mobile drawer actions
      toggleMobileDrawer: () => set(state => ({ mobileDrawerOpen: !state.mobileDrawerOpen })),
      openMobileDrawer: () => set({ mobileDrawerOpen: true }),
      closeMobileDrawer: () => set({ mobileDrawerOpen: false }),
      
      // View toggles
      toggleContentView: () => set(state => ({ 
        contentListView: state.contentListView === 'grid' ? 'list' : 'grid' 
      })),
      setContentView: (view) => set({ contentListView: view }),
      
      // Sidebar width and collapse
      setSidebarWidth: (width) => set({ sidebarWidth: width }),
      toggleSidebarCollapse: () => set(state => ({ 
        sidebarCollapsed: !state.sidebarCollapsed,
        sidebarWidth: state.sidebarCollapsed ? 240 : 72
      })),
    }),
    {
      name: 'aghrba-ui-storage',
    }
  )
);

export default useUIStore;
